import React, { useState, useEffect } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import SimpleBar from "simplebar-react";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import { getExchangeRates as onGetExchangeRates } from "../../slices/thunks";
import moment from "moment-timezone";

const ExchangeRatesClass = () => {
  const dispatch = useDispatch();
  const [exchangeRatesList, setExchangeRatesList] = useState([]);

  const selectExchangeRatesLayoutState = (state) => state.Crm;
  const exchangeRatesData = createSelector(
    selectExchangeRatesLayoutState,
    (state) => ({
      exchangeRates: state.exchangeRates,
      isExchangeRatesSuccess: state.isExchangeRatesSuccess,
      errorExchangeRates: state.errorExchangeRates,
    })
  );

  const { exchangeRates } = useSelector(exchangeRatesData);

  const handleValidDateTime = (time) => {
    if (!time) return "";
    const parsed = new Date(time);
    if (isNaN(parsed.getTime())) return "";
    return moment.tz(parsed, "Asia/Ulaanbaatar").format("YYYY-MM-DD HH:mm:ss");
  };

  useEffect(() => {
    const fetchExchangeRates = () => {
      dispatch(onGetExchangeRates());
    };

    fetchExchangeRates();

    const interval = setInterval(() => {
      fetchExchangeRates();
    }, 90000);

    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(exchangeRates) && exchangeRates.length > 0) {
      setExchangeRatesList(exchangeRates);
    }
  }, [exchangeRates]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <Dropdown
      isOpen={isDropdownOpen}
      toggle={toggleDropdown}
      className="topbar-head-dropdown ms-1 header-item"
    >
      <DropdownToggle
        type="button"
        tag="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
      >
        <i className="ri-refund-2-line fs-22"></i>
        <span className="position-absolute cartitem-badge topbar-badge fs-10 translate-middle badge rounded-pill bg-success">
          {exchangeRatesList.length}
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-xl dropdown-menu-end p-0 dropdown-menu-cart">
        <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
          <Row className="align-items-center">
            <Col>
              <h6 className="m-0 fs-16 fw-semibold">
                ХХБ-ны ханш{" "}
                <span className="fw-normal"> | Бэлэн бус - Зарах |</span>
              </h6>
            </Col>

            <div className="col-auto">
              <span className="badge bg-info-subtle text-info fs-13">
                {exchangeRatesList[0]?.date
                  ? moment(exchangeRatesList[0].date).format("YYYY-MM-DD")
                  : ""}
              </span>
            </div>
          </Row>
        </div>
        <SimpleBar style={{ maxHeight: "300px" }}>
          <div className="p-2">
            {exchangeRatesList[0]?.rates.map((item, key) => (
              <div
                className="d-block dropdown-item text-wrap px-3 py-2"
                key={key}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={item.img || dummyImg}
                    className="me-3 rounded-circle avatar-sm p-2 bg-light"
                    alt={item.name}
                  />
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1 fs-14">{item.name}</h6>
                    <p className="mb-0 fs-12 text-muted">
                      <span className="badge bg-info-subtle text-info fs-13">
                        {item.code}
                      </span>
                    </p>
                  </div>
                  <div className="px-2">
                    <h5 className="m-0 fw-normal">
                      <span className="text-secondary">
                        {item.cashSell.toLocaleString()} ₮
                      </span>
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </SimpleBar>
        <div
          className="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border"
          id="checkout-elem"
        >
          <div className="d-flex justify-content-between align-items-center pb-3">
            <h5 className="m-0 text-muted">Шинэчлэсэн огноо:</h5>
            <div className="px-2">
              <h5 className="m-0">
                <span className="cart-item-total text-success">
                  {exchangeRatesList[0]?.date
                    ? handleValidDateTime(exchangeRatesList[0].scraped_date)
                    : ""}
                </span>
              </h5>
            </div>
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExchangeRatesClass;
